var exports = {
  "d5": "xe533113f--5a26db--head",
  "pq": "xe533113f--5a26db--info",
  "FI": "xe533113f--5a26db--panorama-button",
  "iW": "xe533113f--5a26db--main",
  "gx": "xe533113f--5a26db--newbuilding-info",
  "C5": "xe533113f--5a26db--location",
  "lp": "xe533113f--5a26db--transport-accessibility",
  "bC": "xe533113f--5a26db--hide-if-empty",
};

module.exports = exports;
